import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'

// import CardsMenu from '../components/cardsMenu.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/carusel',
    name: 'carusel',
    component: () => import('../views/home/carusel.vue')
  },
  {path: '/example', name: 'exampleComponent', component: () => import('../views/example.vue')},
  {path: '/prueba', name: 'prueba', component: () => import('../views/prueba.vue')},
  {path:'/componentes',name:'componente', component: () => import('../views/components.vue')},
  // RUTAS DE LA SECCIÓN DE CONOCENOS -> Secretaria de hacienda
  {
    path: '/conocenos',
    name: 'conocenos',
    component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/Conocenos.vue'),
    children: [
      /****Conocenos/Secretaria-de-hacienda* */
      {path: 'secretaria-de-hacienda', name:'secretaria-de-finanzas', component: () => import('../views/conocenos/SecretariaHacienda/OpcSecretariaHacienda.vue') },
      {path: 'secretaria-de-hacienda/mision-vision', name:'conocenos-mision-vision', component: () => import('../views/conocenos/SecretariaHacienda/MisionVision.vue') },
      {path: 'secretaria-de-hacienda/reglamento-interior', name:'conocenos-reglamento-interior', component: () => import('../views/conocenos/SecretariaHacienda/reglamentoInterior.vue') },
      {path: 'secretaria-de-hacienda/programas-institucionales', name:'conocenos-programas-institucionales', component: () => import('../views/conocenos/SecretariaHacienda/programasInstitucionales.vue') },
      {path: 'secretaria-de-hacienda/indicadores-de-gestion', name:'conocenos-indicadores-de-gestion', component: () => import('../views/conocenos/SecretariaHacienda/IndicadoresGestion.vue') },
      {path: 'secretaria-de-hacienda/organigrama', name:'conocenos-organigrama', component: () => import('../views/conocenos/SecretariaHacienda/Organigrama.vue') },
      {path: 'secretaria-de-hacienda/directorio', name:'conocenos-directorio', component: () => import('../views/conocenos/SecretariaHacienda/Directorio.vue') },
      /// IMPORTANTE DIRECTORIO DE PRUEBA
      // {path: 'secretaria-de-hacienda/directorio2', name:'conocenos-directorio-secretaria-de-hacienda', component: () => import('../views/conocenos/SecretariaHacienda/directorio-organosAdmin.vue') },
      {path: 'secretaria-de-hacienda/directorioSH', name:'conocenos-directorio-secretaria-de-hacienda', component: () => import('../views/conocenos/SecretariaHacienda/directorio-organosAdmin.vue') },

       /****Conocenos/manuales-administrativos* */
       {path: 'manuales-administrativos', name:'manuales-administrativos', component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/ManualesAdministrativos/OpcManualesAdmin.vue'),},
       {path: 'manuales-administrativos/manual-de-induccion', name:'conocenos-manual-de-induccion', component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/ManualesAdministrativos/ManualInduccion.vue') },
       {path: 'manuales-administrativos/manual-de-organizacion', name:'conocenos-manual-de-organizacion' , component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/ManualesAdministrativos/ManualOrganizacion.vue') },
       {path: 'manuales-administrativos/manual-de-procedimientos', name:'conocenos-manual-de-procedimientos', component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/ManualesAdministrativos/ManualProcedimientos.vue') },
      //  {path: 'manuales-administrativos/tramites-servicios',  name: 'tramites-servicios', component: () => import('../views/conocenos/ManualesAdministrativos/TramiteServicios.vue') },
      //  {path: 'manuales-administrativos/cedula-servicio/:idTramite/token=:token?', name: 'cedula-servicio', component: () => import('../views/conocenos/ManualesAdministrativos/cedulaTramite.vue')},

       /******  Conocenos/Integridad Pública *******/
       {path: 'integridad-publica', name:'integridadPublica', component: () => import('../views/conocenos/integridadPublica/integridadOpciones.vue'),},
       {path: 'integridad-publica/comite-de-etica-y-prevencion-de-conflictos-de-interes', name:'comiteEticaPrevencionCI', component: () => import('../views/conocenos/integridadPublica/comiteDeEticaPrevencionConflictosIntereses'),},

  ]
  },

  //======================================================
  ///Trámites y servicios
  {path: '/tramites-servicios',  name: 'tramites-servicios', component: () => import('../views/conocenos/ManualesAdministrativos/TramiteServicios2.vue') },
  {path: '/cedula-servicio/:idTramite', name: 'cedula-servicio', component: () => import('../views/conocenos/ManualesAdministrativos/TramiteServicios2.vue') }, // import('../views/conocenos/ManualesAdministrativos/cedulaTramite.vue')},


  //=============================
  {
    path: '/servicio-contribuyente',
    name: 'servicio-contribuyente',
    component: () => import(/* webpackChunkName: "conocenos" */ '../views/Servicio-contribuyente.vue')
  },
  {
    path: '/legislacion',
    name: 'legislacion',
    component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/Legislacion.vue'),
    children: [
      // /legislacion/municipal
      {path: 'municipal', name:'municipal', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/municipal/OpcMunicipal.vue') },
      {path: 'municipal/leyes', name:'municipal-leyes', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/municipal/leyes.vue') },
      {path: 'municipal/ley-de-ingreso-municipal', name:'municipal-ley-de-ingreso-municipal', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/municipal/leyIngresoMpal.vue') },
      {path: 'municipal/otros', name:'municipal-otros',component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/municipal/otros.vue') },
      // /legislacion/estatal
      {path: 'estatal', name:'estatal', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/OpcEstatal.vue') },
      {path: 'estatal/leyes-y-decretos', name:'estatal-leyes-y-decretos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Leyes-decretos.vue') },
      {path: 'estatal/acuerdos', name:'estatal-acuerdos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Acuerdos.vue') },
      {path: 'estatal/acuerdos/historico', name:'estatal-acuerdos-historico', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/historico.vue') },
      {path: 'estatal/normas', name:'estatal-normas', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Normas.vue') },
      {path: 'estatal/reglamentos-y-lineamientos', name:'estatal-reglamentos-y-lineamientos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Reglamentos-lineamientos.vue') },
      {path: 'estatal/convenios-y-otros', name:'estatal-convenios-y-otros', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Convenios-otros.vue') },
      {path: 'estatal/cursos-y-talleres-de-capacitacion', name:'estatal-cursos-y-talleres-de-capacitacion', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Cursos-talleres.vue') },


      // /legislacion/federal
      {path: 'federal', name:'federal', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/opcFederal.vue') },
      {path: 'federal/leyes', name:'federal-leyes', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/leyes.vue') },
      {path: 'federal/decretos', name:'federal-decretos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/decretos.vue') },
      {path: 'federal/acuerdos', name:'federal-acuerdos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/acuerdos.vue') },
      {path: 'federal/reglamentos', name:'federal-reglamentos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/reglamentos.vue') },
      {path: 'federal/reglas', name:'federal-reglas', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/reglas.vue') },
      {path: 'federal/lineamientos', name:'federal-lineamientos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/lineamientos.vue') },
      {path: 'federal/disposiciones-conac', name:'federal-disposiciones-conac', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/disposiciones.vue') },


      // /legislacion/periodico
      {path: 'periodico-oficial', name:'legislacion-periodico-oficial', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/periodicoOficial/PeriodicoOficial.vue') },

    ]
  },
  {
    path: '/rendicion-de-cuentas',
    name: 'rendicion-de-cuentas',
    component: () => import(/* webpackChunkName: "rendicion-de-cuentas" */ '../views/rendicionDeCuentas/rendicionDeCuentas.vue'),
    children:[
      { path:'Menu', name:"Menu",component:() => import('../views/rendicionDeCuentas/Menu.vue') },
      { path:'ProcesoCompetitivo', name:"ProcesoCompetitivo",component:() => import('../views/rendicionDeCuentas/ProcesoCompetitivo.vue') },
      { path:'ProcesoCompetitivo2', name:"ProcesoCompetitivo2",component:() => import('../views/rendicionDeCuentas/ProcesoCompetitivo2.vue') },
      { path:'Presupuesto-de-Egresos', name:"Presupuesto-de-Egresos",component:() => import('../views/rendicionDeCuentas/presupuestoDeEgresos/principalPE.vue') },
      // /rendicion-de-cuentas/Finanzas-publicas
      { path:'Finanzas-publicas', name:"Finanzas-publicas",component:() => import('../views/rendicionDeCuentas/InformeFinanzasPublicas/Finanzas-publicas.vue') },
      { path:'Finanzas-publicas/Evolucion-gasto-publico', name:"IFP-Evolucion-gasto-publico",component:() => import('../views/rendicionDeCuentas/InformeFinanzasPublicas/EvolucionGasto.vue') },
      { path:'Finanzas-publicas/Elementos-Programaticos', name:"IFP-Elementos-Programaticos",component:() => import('../views/rendicionDeCuentas/InformeFinanzasPublicas/Elementos-Programaticos.vue') },
      { path:'Finanzas-publicas/Informes-Contables', name:"IFP-Informes-Contables",component:() => import('../views/rendicionDeCuentas/InformeFinanzasPublicas/Informes-Contables.vue') },
      { path:'Finanzas-publicas/Proceso-Contratacion-Deuda-Publica', name:"IFP-Proceso-Contratacion-Deuda-Publica", component:() => import('../views/rendicionDeCuentas/InformeFinanzasPublicas/Proceso-Contratacion-Deuda-Publica.vue') },


      { path:'Finanzas-publicas/Entes-Publicos', name:"IFP-Entes-Publicos",component:() => import('../views/rendicionDeCuentas/InformeFinanzasPublicas/EntesPublicos.vue') },



      { path:'Gestion-financiera', name:"Gestion-financiera",component:() => import('../views/rendicionDeCuentas/informeAvanGestFinan/Gestion-financiera.vue') },
      // /rendicion-de-cuentas/Recursos-a-Municipios
      { path:'Recursos-a-Municipios', name:"Recursos-a-Municipios",component:() => import('../views/rendicionDeCuentas/recursosaMunicipios/Recursos-a-Municipios.vue') },
      { path:'Recursos-a-Municipios/Participaciones-Federales-Municipios', name:"Participaciones-Federales-Municipios",component:() => import('../views/rendicionDeCuentas/recursosaMunicipios/Participacion-Federal-Mun.vue') },
      { path:'Recursos-a-Municipios/Participaciones-Federales-Municipios/SistemaFrmBusca', name:"SistemaFrmBusca",component:() => import('../views/rendicionDeCuentas/recursosaMunicipios/SistemaFrmBusca.vue') },

      { path:'Recursos-a-Municipios/Aportaciones-Federales-Municipios', name:"Aportaciones-Federales-Municipios",component:() => import('../views/rendicionDeCuentas/recursosaMunicipios/Aportaciones-Federales-Municipios.vue') },
      { path:'Recursos-a-Municipios/Participaciones-Aportaciones-Mun', name:"Participaciones-Aportaciones-Mun",component:() => import('../views/rendicionDeCuentas/recursosaMunicipios/Participaciones-Aportaciones-Mun.vue') },
      { path:'Recursos-a-Municipios/Proyectos-Desarrollo-Regional', name:"Proyectos-Desarrollo-Regional",component:() => import('../views/rendicionDeCuentas/recursosaMunicipios/Proyectos-Desarrollo-Regional.vue') },
      { path:'Recursos-a-Municipios/Fondo-Fortalec-Infra-Estatal-Mpal', name:"Fondo-Fortalec-Infra-Estatal-Mpal",component:() => import('../views/rendicionDeCuentas/recursosaMunicipios/Fondo-Fortalec-Infra-Estatal-Mpal.vue') },
      { path:'Recursos-a-Municipios/Fondo-Fronteras', name:"Fondo-Fronteras",component:() => import('../views/rendicionDeCuentas/recursosaMunicipios/Fondo-Fronteras.vue') },
      { path:'Recursos-a-Municipios/Subsidio-FORTASEG', name:"Subsidio-FORTASEG",component:() => import('../views/rendicionDeCuentas/recursosaMunicipios/Subsidio-FORTASEG.vue') },
      { path:'Estrategico-institucional-org-pub', name:"Estrategico-institucional-org-pub",component:() => import('../views/rendicionDeCuentas/estrategicoInstitucionalporOrgPub/Estrategico-institucional-org-pub.vue') },
      { path:'Cuentas-Publicas', name:"Cuentas-Publicas",component:() => import('../views/rendicionDeCuentas/cuentasPublicas/Cuentas-publicas.vue')},
      { path:'Cuentas-Publicas/CP2015-RB-TII', name:"CP2015-RB-TII",component:() => import('../views/rendicionDeCuentas/cuentasPublicas/CP-Relacion-Bienes-2015-TII') },
      { path:'Cuentas-Publicas/CP2015-RB-TVI', name:"CP2015-RB-TVI",component:() => import('../views/rendicionDeCuentas/cuentasPublicas/CP-Relacion-Bienes-2015-TVI') },
      { path:'Cuentas-Publicas/CP2014-EPyPOP-TII', name:"CP2014-EPyPOP-TII",component:() => import('../views/rendicionDeCuentas/cuentasPublicas/CP-EPyPOP-2014-TII') },
      { path:'Cuentas-Publicas/CP2014-EPyPOP-TVI', name:"CP2014-EPyPOP-TVI",component:() => import('../views/rendicionDeCuentas/cuentasPublicas/CP-EPyPOP-2014-TVI') },
      { path:'Cuentas-Publicas/CP2014-RB-TVI', name:"CP2014-RB-TVI",component:() => import('../views/rendicionDeCuentas/cuentasPublicas/CP-Relacion-Bienes-2014-TVI') },

      { path:'Trimestral-publicas', name:"Trimestral-publicas",component:() => import('../views/rendicionDeCuentas/informeAvanceTrimCtaPub/Trimestral-publicas.vue') },
      { path:'Presup-egres-org-pub', name:"Presup-egres-org-pub",component:() => import('../views/rendicionDeCuentas/presupuestodeEgresosporOrgPub/Presup-egres-org-pub.vue') },
      { path:'SFU', name:"SFU",component:() => import('../views/rendicionDeCuentas/presupuestoDeEgresos/SFU.vue') },
      { path:'SRFT', name:"SRFT",component:() => import('../views/rendicionDeCuentas/presupuestoDeEgresos/SRFT.vue') },
      // { path:'InformeFinanzasPublicas/EvolucionGasto', name:"EvolucionGasto",component:() => import('../views/rendicionDeCuentas/InformeFinanzasPublicas/EvolucionGasto.vue') },
    ]
  },
  {
    path: '/armonizacionContable',
    name: 'armonizacionContable',
    component: () => import(/* webpackChunkName: "rendicion-de-cuentas" */ '../views/ArmonizacionContable/ArmonizacionContable.vue'),
    children:[
      { path:'Menu', name:"MenuArmonizacion",component:() => import('../views/ArmonizacionContable/ArmonizacionContableMenu.vue') },
      { path:'avanceChiapas', name:"avanceChiapas",component:() => import('../views/ArmonizacionContable/AvanceChiapas.vue') },
      { path:'documentosAprobadosConac', name:"documentosAprobadosConac",component:() => import('../views/ArmonizacionContable/docAprobadosConac.vue') },
      { path:'documentosPublicadosChiapas', name:"documentosPublicadosChiapas",component:() => import('../views/ArmonizacionContable/docPublicadosChiapas.vue') },
      { path:'resultadosEvaluaciones', name:"resultadosEvaluaciones",component:() => import('../views/ArmonizacionContable/resultadosEvaluaciones.vue') },
      { path:'informesSHaciendaConac', name:"informesSHaciendaConac",component:() => import('../views/ArmonizacionContable/informesSHaciendaFormatosConac.vue') },

      { path:'informacionConsolidada', name:"informacionConsolidada",component:() => import('../views/ArmonizacionContable/FormatosConac/informacionConsolidada.vue') },
      { path:'provisionesSalarialesEconomicas', name:"provisionesSalarialesEconomicas",component:() => import('../views/ArmonizacionContable/FormatosConac/provisionesSalarialesEconomicas.vue') },
      { path:'organismosSubsidiados', name:"organismosSubsidiados",component:() => import('../views/ArmonizacionContable/FormatosConac/organismosSubsidiados.vue') },
      { path:'ayudaCiudadania', name:"ayudaCiudadania",component:() => import('../views/ArmonizacionContable/FormatosConac/ayudasCiudadania.vue') },
      { path:'deudaPublica', name:"deudaPublica",component:() => import('../views/ArmonizacionContable/FormatosConac/deudaPublica.vue') },
      { path:'obligaciones', name:"obligaciones",component:() => import('../views/ArmonizacionContable/FormatosConac/obligaciones.vue') },
      { path:'municipios', name:"municipios",component:() => import('../views/ArmonizacionContable/FormatosConac/municipios.vue') },
      {
        path:'secretariaHacienda',
        name:"secretariaHacienda",
        component:() => import('../views/ArmonizacionContable/FormatosConac/SecretariaHacienda/secretariaHaciendaMenu.vue'),
        children:[
          { path:'SHacienda', name:"SHacienda",component:() => import('../views/ArmonizacionContable/FormatosConac/SecretariaHacienda/SHacienda/SHContenedor.vue') },
          { path:'InventarioBienes', name:"InventarioBienes",component:() => import('../views/ArmonizacionContable/FormatosConac/SecretariaHacienda/inventarioBienes/inventarioBienesContenedor.vue') },
          { path:'CuentaPublicaFinanciera', name:"CuentaPublicaFinanciera",component:() => import('../views/ArmonizacionContable/FormatosConac/SecretariaHacienda/cuentaPublicaFinanciera/CuentaPublicaFinanciera.vue') },
          { path:'CuentaPublicaPresupuestal', name:"CuentaPublicaPresupuestal",component:() => import('../views/ArmonizacionContable/FormatosConac/SecretariaHacienda/cuentaPublicaPresupuestal/cuentaPublicaPresupuestal.vue') },
          { path:'InformacionContable', name:"InformacionContable",component:() => import('../views/ArmonizacionContable/FormatosConac/SecretariaHacienda/informacionContable/informacionContable.vue') },
          { path:'InformacionPresupuestal', name:"InformacionPresupuestal",component:() => import('../views/ArmonizacionContable/FormatosConac/SecretariaHacienda/informacionPresupuestal/InformacionPresupuestal.vue') },
          { path:'InformacionProgramatica', name:"InformacionProgramatica",component:() => import('../views/ArmonizacionContable/FormatosConac/SecretariaHacienda/informacionProgramatica/InformacionProgramatica.vue') },

        ]
      },

    ]
  },
  // notificaciones por estrados y por edictos
  {path:'/notificaciones-por-estrados',name:'NotificacionesPorEstrados', component: () => import('../views/notificaciones/notificacionesPorEstrados.vue')},
  {path:'/notificaciones-por-edictos',name:'NotificacionesPorEdictos', component: () => import('../views/notificaciones/notificacionesPorEdictos.vue')},
  { path:'/tesoreria', name:"tesoreria",component:() => import('../views/TesoreriaApp/tesoreria.vue') },

  // rutas temporales
  { path:'/correccionJson', name:"correccionJson",component:() => import('../views/ArmonizacionContable/CorreccionJson.vue') },
  { path:'/modeloPrueba', name:"modeloPrueba",component:() => import('../views/JsonModels/modelo.vue') },
  { path:'/modeloTemp', name:"modeloTemp",component:() => import('../views/JsonModels/modeloTemp.vue') },
  { path:'/modeloTemp2', name:"modeloTemp2",component:() => import('../views/JsonModels/modeloTemp2.vue') },
  { path:'/modelo10', name:"modelo10",component:() => import('../views/JsonModels/modelo10.vue') },
  { path:'/modelo1', name:"modelo1",component:() => import('../views/JsonModels/modelo1.vue') },
  { path:'/modelo5', name:"modelo5",component:() => import('../views/JsonModels/modelo5.vue') },
  { path:'/modeloAvisoPrivacidad', name:"modeloAvisoPrivacidad",component:() => import('../views/JsonModels/avisoPrivacidad.modelo.vue') },
  { path:'/tab', name:"tab",component:() => import('../components/tab.vue') },

  {
    path: '/planeacion',
    name: 'planeacion',
    component: () => import(/* webpackChunkName: "legislacion" */ '../views/planeacion/planeacion.vue')
  },
  {
    path: '/PED',
    name: 'PED',
    component: () => import(/* webpackChunkName: "legislacion" */ '../views/planeacion/PED.vue')
  },
  {
    path: '/funcionarios',
    name: 'funcionarios',
    component: () => import(/* webpackChunkName: "funcionarios" */ '../views/funcionarios/HomeFuncionarios.vue')
  },
  {
    path: '/transparencia',
    name: 'transparencia',
    component: () => import(/* webpackChunkName: "funcionarios" */ '../views/transparencia/transparencia.vue')
  },
  /***Enlaces de interes */
  {
    path: '/enlaces-de-interes',
    name: 'enlaces-de-interes',
    component: () => import(/* webpackChunkName: "funcionarios" */ '../views/home/enlaces-de-interes.vue')
  },

  {
    path: '/pago-contribuciones',
    name: 'pago-contribuciones',
    component: () => import(/* webpackChunkName: "funcionarios" */ '../views/home/pago-contribuciones.vue')
  },
/********PROBANDO ARCHIVOS DE PRUEBA DE SERVICIOS RUTAS DE PRUEBA!!!!!*********** */
{
  path: '/servicios',
  name: 'servicios',
  component: () => import(/* webpackChunkName: "servicios" */ '../views/Tramites/tramites.vue')
},
//*****Ruta que consulta el detalle de la cedula pero con el json */
//  {
//    path: '/cedula-servicio/:idTramite',
//    name: 'cedula-servicios',
//    component: () => import(/* webpackChunkName: "nombreTramite" */ '../views/Tramites/cedulaTramite.vue')
//  },
////**Ruta que consulta el detalle de la cedula con el servicio////
 {
   path: '/cedula-servicio2/:idTramite/token=:token',
   name: 'cedula-servicios',
   component: () => import(/* webpackChunkName: "nombreTramite" */ '../views/Tramites/cedulaTramite.vue')
 },
///////////**************************************/////////////////////////////////////
/////********Aviso de privacidad */
{
  path: '/aviso-de-privacidad',
  name: 'aviso-de-privacidad',
  component: () => import(/* webpackChunkName: "nombreTramite" */ '../views/avisoPrivacidad/avisoPrivacidad.vue'),
},

{path: '/aviso-de-privacidad/aviso', name: 'avisoComponent', component: () => import('../views/avisoPrivacidad/aviso.vue')},
{
  path: '/aviso-privacidad-licencias',
  name: 'AvisoPrivacidadLicencias',
  component: () => import('../views/avisoPrivacidad/avisoPrivacidadLicencias.vue')
},
//| SALA DE PRENSA |\\
{
  path: '/prensa',
  name: 'prensa',
  component: () => import('../views/sala-de-prensa/SalaPrensa.vue'),
  children: [
    {path: '/prensa/vista-listado/:filtros?', name: 'listado', component: () => import('../views/sala-de-prensa/VistaListado.vue')},
    // {path: '/prensa/vista-detalle/:id?', name: 'detalle',component: () => import('../views/sala-de-prensa/VistaDetalle.vue')},
    {path: '/prensa/vista-detalle/:id?/:titular?', name: 'detalle',component: () => import('../views/sala-de-prensa/VistaDetalle.vue')}
  ]
},
{
  path: '/foprovep',
  name: 'foprovep',
  component: () => import('../views/foprovep/homeFoprovep.vue'),
  children: [
    {path: '/foprovep/menu-principal', name: 'menuQuienesSomos', component: () => import('../views/foprovep/menuPrincipal.vue')},

    {path: '/foprovep/quienesSomos', name: 'quienesSomos', component: () => import('../views/foprovep/quienessomos/quienes_somos.vue')},
    {path: '/foprovep/quienesSomos/somosFoprovep', name: 'somosfoprovep', component: () => import('../views/foprovep/quienessomos/foprovep.vue')},
    {path: '/foprovep/quienesSomos/mision-vision', name: 'mision-vision', component: () => import('../views/foprovep/quienessomos/misionVision.vue')},
    {path: '/foprovep/quienesSomos/organigrama', name: 'organigrama', component: () => import('../views/foprovep/quienessomos/organigrama.vue')},
    {path: '/foprovep/quienesSomos/proposito-areas', name: 'proposito-areas', component: () => import('../views/foprovep/quienessomos/propositoAreas.vue')},
    {path: '/foprovep/quienesSomos/comite-tecnico', name: 'comite-tecnico', component: () => import('../views/foprovep/quienessomos/comiteTecnico.vue')},

    ///Rutas sección información
    {path: '/foprovep/informacion', name: 'informacion', component: () => import('../views/foprovep/informacion/informacion.vue')},
    {path: '/foprovep/informacion/coberturas', name: 'coberturas', component: () => import('../views/foprovep/informacion/coberturas.vue') },
    {path: '/foprovep/informacion/exclusion-de-coberturas', name: 'exclusion-de-coberturas', component: () => import('../views/foprovep/informacion/exclusion_cobertura.vue') },
    {path: '/foprovep/informacion/validez-de-aseguramiento', name: 'validez-de-aseguramiento', component: () => import('../views/foprovep/informacion/validez_aseguramiento.vue') },
    {path: '/foprovep/informacion/siniestro', name: 'siniestro', component: () => import('../views/foprovep/informacion/siniestro.vue') },
    {path: '/foprovep/informacion/primas-de-aseguramiento', name: 'primas-de-aseguramiento', component: () => import('../views/foprovep/informacion/primas-aseguramiento.vue') },
    {path: '/foprovep/informacion/ajustadores-autorizados', name: 'ajustadores-autorizados', component: () => import('../views/foprovep/informacion/ajustadores_autorizados.vue') },

    {path: '/foprovep/otrosDocumentos', name: 'otros', component: () => import('../views/foprovep/otros/otrosDocumentos.vue')},
    {path: '/foprovep/otrosDocumentos/informacion-contable', name: 'informacion-contable', component: () => import('../views/foprovep/otros/informacionContable.vue')},
    {path: '/foprovep/otrosDocumentos/formatos-dependencia', name: 'formatos-dependencia', component: () => import('../views/foprovep/otros/formatos.vue')},
    {path: '/foprovep/otrosDocumentos/reglas-operacion', name: 'reglas-operacion', component: () => import('../views/foprovep/otros/reglasOperacion.vue')}

  ]
},
//////////MODULO DE BECAS///////////////
{
  path: '/becas-a-servidores-publicos',
  name: 'becas-a-servidores-publicos',
  component: () => import(/* webpackChunkName: "nombreTramite" */ '../views/becasServidoresPublicos/becasServidoresPublicos.vue')
},

// --- Tramites de api de planeación ---
{
  path: '/modulo-planeacion',
  name: 'modulo-planeacion',
  component: () => import('../views/TramitesHacienda/planeacion.vue')
},
{
  path: '/modulo-planeacion/manual-de-formatos',
  name: 'manual-de-formatos',
  component: () => import('../views/TramitesHacienda/vistas_planeacion/manual_formatos.vue')
},
{
  path: '/modulo-planeacion/curso-de-Capacitacion',
  name: 'curso-de-Capacitacion',
  component: () => import('../views/TramitesHacienda/vistas_planeacion/curso-de-Capacitacion.vue')
},
{
  path: '/login-registro',
  name: 'loginRegistro',
  component: () => import('../views/TramitesHacienda/loginRegistro.vue')
},
{
  path: '/TramitesHacienda',
  name: 'TramitesHacienda',
  component: () => import('../views/TramitesHacienda/tramites.vue')
},
{
  path: '/TramitesHaciendaExternos',
  name: 'TramitesHaciendaExternos',
  component: () => import('../views/TramitesHacienda/tramitesExternos/tramitesExternos.vue')
},

  /* ---- ESTA RUTA DEBE SER LA ULTIMA ---- */
  {
    path: '*',
    name: '404',
    component: () => import('../views/404.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
